import {h} from 'preact';
import * as BaseComp from 'components/bolt/gallery/gallery';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';



import Section from 'components/bolt/section/section';
import Store from 'store/store';
import 'store/bolt/gallery';
import { joinClasses } from 'utils/utils';
import VideoPlayer from 'components/bolt/videos/player';
import s from 'components/bolt/gallery/gallery.sss';

export default class Gallery extends BaseComp.default {
	componentDidMount(...args) {
		super.componentDidMount?.(...args);
		observeScroll(this.base);
	}

	componentWillUnmount(...args) {
		super.componentWillUnmount?.(...args);
		unobserveScroll(this.base);
	}

	renderVideo() {
		const { loading, playing } = this.state;
		const video = this.getActiveImage();
		const isYoutube = video.youtubeId;
		const pageId = this.props?.id;
		const pageData = this.props?.appData?.pages[pageId]?.data || {};

		return (
			<div
				class={joinClasses(s.videoContainer, loading && s.loading)}
				ref={ref => this.videoContainer = ref}
				onMouseDown={!isYoutube && this.onDragStart}
				onTouchStart={!isYoutube && this.onDragStart}
				onMouseMove={!isYoutube && this.onDrag}
				onTouchMove={!isYoutube && this.onDrag}
				onMouseUp={!isYoutube && this.onDragEnd}
				onTouchEnd={!isYoutube && this.onDragEnd}
			>
				<VideoPlayer
					ref={ref => this.videoPlayer = ref}
					activeVideo={video}
					onPlay={() => this.togglePlaying(true)}
					onPause={() => this.togglePlaying(false)}
					noAutoplay={video.noAutoplay}
					onLoaded={this.onLoadedHandler}
					onEnded={() => this.onEndedHandler(video)}
					overrideStyles
					muted={pageData.autoMuteVideos}
				/>
				{isYoutube && this.state.images.length > 1 && (
					<div
						onMouseDown={this.onDragStart}
						onTouchStart={this.onDragStart}
						onMouseMove={this.onDrag}
						onTouchMove={this.onDrag}
						onMouseUp={this.onDragEnd}
						onTouchEnd={this.onDragEnd}
						onClick={this.videoClickHandler}
						class={s.touchOverlay}
						style={{ pointerEvents: playing ? 'none' : 'all' }}
					/>
				)}
			</div>
		);
	}
}